// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + {"8":"packages","138":"profile","190":"newsletter","594":"about","681":"promotions","699":"verify-email","941":"my-quotes","953":"package-detail"}[chunkId] + "." + {"8":"66109368","138":"bb854885","190":"eb6deb50","594":"e41e610d","681":"6480a24f","699":"c70b0c4a","941":"bbccf037","953":"9d79a15d"}[chunkId] + ".js";
};